import { useTranslation } from 'react-i18next';

import { cn } from '~/lib/cn';
import type { VariantProps } from '~/lib/variants';
import { variants } from '~/lib/variants';

type SpinnerProps = VariantProps<typeof spinnerVariants>;

const spinnerVariants = variants({
  base: 'animate-spin rounded-full border-sm border-primary-disabled border-t-primary-default',
  variants: {
    size: {
      xs: 'size-md border-2xs',
      sm: 'size-lg border-2xs',
      md: 'size-2xl border-xs',
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

export function Spinner({ size }: SpinnerProps) {
  const { t } = useTranslation('common');
  const spinnerClassName = spinnerVariants({ size });

  return (
    <div
      className={cn(spinnerClassName)}
      role="status"
      aria-busy="true"
      aria-label={t('loading')}
      aria-live="polite"
    />
  );
}

Spinner.displayName = 'Spinner';
